var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F822CB43-A2FF-47EA-AE15-A62A65E5C682") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 59.99995 0 59.99995 59.99975 0 59.99975"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Help-Page_V3",
    transform: "translate(-545.000000, -1359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(513.000000, 1327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medal-badge",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.99995,-0.00025 C13.43095,-0.00025 -5e-05,13.43125 -5e-05,29.99975 C-5e-05,46.56875 13.43095,59.99975 29.99995,59.99975 C46.56895,59.99975 59.99995,46.56875 59.99995,29.99975 C59.99995,13.43125 46.56895,-0.00025 29.99995,-0.00025 M29.99995,1.49975 C45.71495,1.49975 58.49995,14.28475 58.49995,29.99975 C58.49995,45.71525 45.71495,58.49975 29.99995,58.49975 C14.28495,58.49975 1.49995,45.71525 1.49995,29.99975 C1.49995,14.28475 14.28495,1.49975 29.99995,1.49975",
    id: "Fill-1",
    fill: "#EDEBE9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(18.575850, 11.393100)",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.29175,4.1921 C18.71475,5.2736 21.42275,9.7361 20.34125,14.1586 C19.25975,18.5811 14.79725,21.2896 10.37425,20.2076 C5.95125,19.1261 3.24275,14.6636 4.32475,10.2416 C5.40625,5.8186 9.86875,3.1101 14.29175,4.1921 Z",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-6",
    points: "14.7488 2.322 18.2013 1.5005 19.3638 4.853 22.7643 5.8685 22.0953 9.3535 24.5328 11.9325 22.2108 14.616 23.0318 18.068 19.6793 19.231 18.6648 22.6315 15.1793 21.962 12.6003 24.3995 9.9168 22.078 6.4648 22.899 5.3013 19.5465 1.9013 18.5315 2.5708 15.0465 0.1333 12.4675 2.4553 9.784 1.6343 6.332 4.9868 5.1685 6.0013 1.7685 9.4868 2.437 12.0658 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    points: "5.3645 21.44945 0 34.19745 6.3015 30.31395 8.872 37.12945 11.5225 24.23045"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    points: "19.65115 21.32735 25.59965 33.98585 19.17215 30.31535 16.83165 37.21335 13.70265 24.18935"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBadge);
export default __webpack_public_path__ + "static/media/medal-badge.22f0b4383751732c2971af04d7fce826.svg";
export { ForwardRef as ReactComponent };